import McItem from "./McItem";
import AudioMcItem from "./AudioMcItem";
import ClozeChoiceItem from "./ClozeChoiceItem";
import MatchPairsItem from "./MatchPairsItem";
import BucketSortItem from "./BucketSortItem";
import TrueFalseItem from "./TrueFalseItem";
import OrderSentenceItem from "./OrderSentenceItem";
import VerbFormItem from "./VerbFormItem";

/** question.type → renderer. Every renderer calls onAnswer({correct, answer}) once. */
export const ITEM_RENDERERS = {
  mc: McItem,
  audio_mc: AudioMcItem,
  cloze_choice: ClozeChoiceItem,
  match_pairs: MatchPairsItem,
  bucket_sort: BucketSortItem,
  true_false: TrueFalseItem,
  order_sentence: OrderSentenceItem,
  verb_form: VerbFormItem,
};

/** Short labels for the progress strip / results breakdown. */
export const TYPE_LABELS = {
  mc: "Choose", audio_mc: "Listen", cloze_choice: "Fill the gap", match_pairs: "Match",
  bucket_sort: "Sort", true_false: "True / false", order_sentence: "Rebuild", verb_form: "Verb forms",
};

export const SKILL_LABELS = {
  vocab: "Vocabulary", comprehension: "Understanding", listening: "Listening",
  production: "Producing", grammar: "Grammar",
};
